import { P as r } from "./Picker-Cpjx4vH1.js";
import { d as m } from "./define-element-Dl91r6Vu.js";
m("sp-picker", r);
//# sourceMappingURL=sp-picker-X_cwvgPh.js.map
